import { useCallback, useEffect, useState } from "react";
import useErrors from "src/hooks/useErrors";
import axiosInstance from "src/utils/fetchUser";

/**
 * Carica la somma commissioni raggruppata per payment_type sul filtro corrente.
 * Riceve un oggetto `filter` (start_date/end_date/user_id/payment_type) e
 * rifetcha quando cambia.
 *
 * Ritorna { breakdown: { payment_type: total }, total, isLoading, refetch }.
 */
const useFetchBreakdown = (filter) => {
  const [breakdown, setBreakdown] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const handleErrors = useErrors();

  const fetch = useCallback(async (params = {}) => {
    setIsLoading(true);
    try {
      const { data, status } = await (
        await axiosInstance.get("ewallet-breakdown", { params })
      ).data;
      if (status) setBreakdown(data || {});
    } catch (err) {
      handleErrors(err);
    } finally {
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Serializzo i filtri per evitare loop su nuove reference dell'oggetto.
  const key = JSON.stringify(filter || {});
  useEffect(() => {
    fetch(filter || {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  const total = Object.values(breakdown).reduce((acc, v) => acc + Number(v || 0), 0);

  return { breakdown, total, isLoading, refetch: fetch };
};

export default useFetchBreakdown;
